"use strict";

// AI Generated Code
// This code is a jQuery plugin that creates a popover element.
(function ($) {
  $.fn.koboPopover = function (options) {
    var settings = $.extend({
      position: 'bottom-left',
      popoverContainerId: 'popoverContainer',
      showOnLoad: false,
      offset: 8
    }, options);
    var popover = $('#' + settings.popoverContainerId);
    var $this;

    function updatePopoverPosition(trigger, position) {
      var offset = trigger.offset();
      var triggerW = trigger.outerWidth();
      var triggerH = trigger.outerHeight();
      var popoverW = popover.outerWidth();
      var popoverH = popover.outerHeight();
      var internalOffset = settings.offset + 10; // Offset + 10px for the arrow

      var top = 0,
          left = 0;
      popover.removeClass('top-left top-middle top-right bottom-left bottom-middle bottom-right').addClass(position); // Positioning logic

      switch (position) {
        case 'top-left':
          top = offset.top - popoverH - internalOffset;
          left = offset.left;
          break;

        case 'top-middle':
          top = offset.top - popoverH - internalOffset;
          left = offset.left + triggerW / 2 - popoverW / 2;
          break;

        case 'top-right':
          top = offset.top - popoverH - internalOffset;
          left = offset.left + triggerW - popoverW;
          break;

        case 'bottom-left':
          top = offset.top + triggerH + internalOffset;
          left = offset.left;
          break;

        case 'bottom-middle':
          top = offset.top + triggerH + internalOffset;
          left = offset.left + triggerW / 2 - popoverW / 2;
          break;

        case 'bottom-right':
          top = offset.top + triggerH + internalOffset;
          left = offset.left + triggerW - popoverW;
          break;

        default:
          top = offset.top + triggerH + internalOffset;
          left = offset.left;
      }

      popover.css({
        top: top,
        left: left
      });
    }

    function _show(trigger, position) {
      updatePopoverPosition(trigger, position);
      popover.appendTo('body');
      popover.fadeIn(150);
      $(document).on('keydown.koboPopover', handlePopoverKeydown);
    }

    function hide() {
      popover.fadeOut(100);
      $(document).off('keydown.koboPopover');
      $('body').focus();
    }

    function handlePopoverKeydown(event) {
      // Focus trapping logic
      if (event.key === 'Tab') {
        var focusableElements = popover.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        var firstFocusableElement = focusableElements[0];
        var lastFocusableElement = focusableElements[focusableElements.length - 1];

        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          event.preventDefault();
        } else {
          firstFocusableElement.focus();
          event.preventDefault();
        }
      }
    }

    this.each(function () {
      $this = $(this);

      if (!settings.showOnLoad) {
        $this.on('click', function () {
          _show($this, settings.position);
        });
      }

      if (settings.showOnLoad) {
        _show($this, settings.position);
      }

      $this.data('koboPopoverSettings', settings);
      $this.data('koboPopoverElement', popover);
      $(window).on('resize', function () {
        if (popover.is(':visible')) {
          updatePopoverPosition($this, settings.position);
        }
      });
    });
    return {
      show: function show() {
        _show($this, settings.position);
      },
      hide: hide
    };
  };
})(jQuery);